import React from "react";
import * as S from "./EasyBoarding.styles";

interface IEasyBoarding {
  margin: string;
  title: string;
  desc: Array<string>;
  image_url: string;
}

const EasyBoardingUI: React.FC<IEasyBoarding> = ({
  margin = '',
  title = '',
  desc = [],
  image_url = '',
}) => {
    if (!title) return null;
    return (
        <S.EasyBoardingContainer margin={margin}>
            <h4 className="font16 textDark fontMedium">{title}</h4>
            <div className="makeFlex hrtlCenter appendTop16">
                <div className="appendRight28 noShrink">
                {!!image_url && <img src={image_url} alt="details" />}
                </div>
                {desc?.length > 0 && <div className="makeFlex column">
                    {desc?.map((item, index) => {
                        return (
                            <div className="makeFlex hrtlCenter" style={{ marginTop: index !== 0 ? '1.6rem' : '0' }}>
                                <div className="appendRight12 points makeFlex perfectCenter">
                                    <p className="font12">{index + 1}</p>
                                </div>
                                <p className="font14 textLightDark">{item}</p>
                            </div>
                        )
                    })}
                </div>}
            </div>
        </S.EasyBoardingContainer>
    );
};

export default EasyBoardingUI;
